import { useMutation } from '@tanstack/react-query';
import type { CreateReviewRequest, ReviewResponse } from '../api/reviewApi';
import { ReviewApi } from '../api/reviewApi';

export function useCreateReview() {
  return useMutation<ReviewResponse, Error, CreateReviewRequest>({
    mutationFn: (data) => ReviewApi.createReview(data),
  });
}
